export default "__VITE_ASSET__BnTutbuB__"